const benefitAccordions = Array.from(document.querySelectorAll('.product-benefit'));
const benefitAccordionHeaders = Array.from(document.querySelectorAll('.product-benefit__header'));

if(benefitAccordions && benefitAccordionHeaders) {
    benefitAccordionHeaders.forEach(header => {
        header.addEventListener('click', () => {
            const index = benefitAccordionHeaders.indexOf(header);
            const state = benefitAccordions[index].getAttribute('aria-expanded') === 'true';

            benefitAccordions[index].setAttribute('aria-expanded', !state);
        })
    })
}